import { EnvironmentOutlined } from '@ant-design/icons';
import { Flex, Space, Switch, Tag, Typography } from 'antd';
import type { ReactNode } from 'react';
import { useState } from 'react';
import { translateInventoryText } from '@/shared/i18n/inventory-i18n';

export function OtherMetersMapSection({
  count,
  countDefaultMessage,
  countMessageId,
  renderMap,
}: {
  count: number;
  countDefaultMessage: string;
  countMessageId: string;
  renderMap: (showOtherMeters: boolean) => ReactNode;
}) {
  const [showOtherMeters, setShowOtherMeters] = useState(true);

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Flex align="center" gap="small" justify="space-between" wrap>
        <Tag icon={<EnvironmentOutlined />}>
          {translateInventoryText(countMessageId, countDefaultMessage, { count })}
        </Tag>
        <Space>
          <Typography.Text>
            {translateInventoryText('app.inventory.position.otherMeters', 'Other meters')}
          </Typography.Text>
          <Switch
            checked={showOtherMeters}
            checkedChildren={translateInventoryText('app.inventory.common.display', 'Display')}
            onChange={setShowOtherMeters}
            unCheckedChildren={translateInventoryText('app.inventory.common.hide', 'Hide')}
          />
        </Space>
      </Flex>
      {renderMap(showOtherMeters)}
    </Space>
  );
}
